import { PlayerConfig } from "../../Config";
import { EventDispatcher } from "../events/EventDispatcher";
export class WorkerLoader {
    static workerSupported() {
        return Worker ? true : false;
    }
    static get enable() {
        return WorkerLoader._enable;
    }
    static set enable(value) {
        if (WorkerLoader._enable != value) {
            if (value) {
                if (!Worker)
                    return;
                if (!WorkerLoader._worker) {
                    WorkerLoader._worker = new Worker(PlayerConfig.workerLoaderLib || WorkerLoader.workerPath);
                    WorkerLoader._worker.onmessage = WorkerLoader.workerMessage;
                    WorkerLoader._dispatcher = new EventDispatcher();
                }
            }
            WorkerLoader._enable = value;
        }
    }
    static load(url, options) {
        return new Promise((resolve, reject) => {
            WorkerLoader._worker.postMessage({ url, options });
            WorkerLoader._dispatcher.once(url, (data) => {
                if (data.imageBitmap)
                    resolve(data.imageBitmap);
                else
                    reject(data.msg);
            });
        });
    }
    static workerMessage(evt) {
        let data = evt.data;
        if (data) {
            switch (data.type) {
                case "Image":
                    WorkerLoader._dispatcher.event(data.url, data);
                    break;
                case "Disable":
                    WorkerLoader.enable = false;
                    break;
            }
        }
    }
}
WorkerLoader.workerPath = "libs/laya.workerloader.js";
WorkerLoader._enable = false;
